import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";
const SaveDataButton = ({ buttonValue, className, onClick, disabled }) => {
  return (
    <button
      value={buttonValue}
      onClick={onClick}
      disabled={disabled}
      className={`hover:scale-90 transition duration-500 w-28 shadow-md border-senary bg-tranparent hover:bg-senary text-senary group relative flex justify-center py-1 px-3 border border-transparent text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70$ ${className}`}
    >
      <ArrowDownCircleIcon className="h-4 w-4 mr-2" />
      {buttonValue}
    </button>
  );
};
export default SaveDataButton;
